import React from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { getEquipmentList } from "../Actions/EquipmentManagementAPI";
import {
  getCategoryList,
  getEquipmentTypeList,
  getEquipmentNameListAndId,
  getMakeList,
  getModelsList,
  getApplicableSeviceTypewithIdList,
} from "../Actions/helpersAPI";
import { AddAttachment, AddGAttachment, AddnewdocAttachmnt, AddEquipManualAttachment } from "../Actions/AttachmentAPI";
import { RadioGroup, Radio, FormControlLabel } from "@material-ui/core";
import swal from "sweetalert";
import axios from "axios";
import API from "../helpers/api";
import Modal from "react-bootstrap/Modal";
import { getServiceTypeList } from "../Actions/CommonAPI";
import AutocompleteField from "react-autocomplete";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { toast } from "react-toastify";
import Role from "../helpers/role";
import { confirmAlert } from "react-confirm-alert";
import $ from "jquery";
import { deleteAttachmentInBucket } from "../Actions/CommonAPI";
import { DropzoneArea } from "material-ui-dropzone";
import { FileCopy, Close, Height, HeightTwoTone, Folder } from "@material-ui/icons";


let currentuser = JSON.parse(localStorage.getItem("currentUser"));
let user = localStorage.getItem("UserRoles");
let searchData = {
  EquipmentId: 0,
  Equipment: "",
  MakeId: 0,
  ModelId: 0,
  Make: "",
  Model: "",
  ServiceType: "",
  EquipmentType: "",
  Category: "",
  ServiceTypeId: 0,
  capacity: "",
  EquipmentCategoryId: 0,
  PageNumber: 1,
  PageSize: 20,
};
var fileDatas = [];

class EquipmentNewScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      AddEquipmentYes: false,
      AddEquipmentNo: true,
      equipmentinfo: {
        equipmentName: "",
        equipmentType: "",
        category: "",
        capacity: "",
        attachmentName: "",
        isAddOnEquipment: false,
        createdBy: currentuser.name,
        createdDate: "",
        files: "",
        attachmentType: "",
        attachmentGuid: "",
        guideAttachmentName: "",
        guideAttachmentGuid: "",
        otherAttachmentName: "",
        otherAttachmentGuid: "",
        equipmentCategoryTypeid: 0,
        selectedFilesAttachmentName: [],
        selectedFilesOtherAttachmentName: [],
        selectedFilesGuideAttachmentName: [],
      },
      EquipmentTypeList: [],
      CategoryTypeList: [],
      modalIsOpen: false,
      isModelNew: true,
      ApplicableServicesList: [],
      applicableservicesdoc: [],
      models: [],
      MakeAndModelDetails: {
        Id: 0,
        makeId: 0,
        makeName: "",
        modelId: 0,
        modelName: "",
        serviceTypeId: 0,
        serviceType: "",
        isShore: false,
        radioButton: "",
        isDeleted: false,
      },
      equipment: "",
      annually: false,
      biannually: false,
      fiveyearly: false,
      tenyearly: false,
      openEquipment: false,
      equipemntConfigTypeList: [],
      keydrop1: Date.now(),
      keydrop3: Date.now(),
      keydrop2: Date.now()
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    // window.onpopstate = () => window.history.forward();
    const { dispatch, attachmentDetail, GattachmentDetail, EquipManualattachmentDetail } = nextProps;
    if (attachmentDetail) {
      prevState.equipmentinfo.attachmentName = attachmentDetail.FileName;
      prevState.equipmentinfo.attachmentGuid = attachmentDetail.Guid;
    }
    if (GattachmentDetail) {
      prevState.equipmentinfo.guideAttachmentName = GattachmentDetail.FileName;
      prevState.equipmentinfo.guideAttachmentGuid = GattachmentDetail.Guid;
    }
    if (EquipManualattachmentDetail) {
      prevState.equipmentinfo.otherAttachmentName = EquipManualattachmentDetail.FileName;
      prevState.equipmentinfo.otherAttachmentGuid = EquipManualattachmentDetail.Guid;
    }
  }

  componentDidMount() {
    const { dispatch } = this.props;
    // dispatch(getCategoryList("category"));
    // dispatch(getEquipmentTypeList("equipmenttype"));
    dispatch({ type: "SubBannerTitle", data: "Equipment Management" });
    this.getEquipmentList("equipmenttype");
    this.getCategoryList("category");
    this.getEquipmentType();
    dispatch(getApplicableSeviceTypewithIdList());
    dispatch(getEquipmentNameListAndId());
    dispatch(getMakeList());
    dispatch(getModelsList());
  }
  getEquipmentList = (type) => {
    let url = `${API.lookupNamelist}?type=${type}`;
    axios.get(url).then((response) => {
      this.setState({ EquipmentTypeList: response.data.list });
    });
  };
  getCategoryList = (type) => {
    let url = `${API.lookupNamelist}?type=${type}`;
    axios.get(url).then((response) => {
      this.setState({ CategoryTypeList: response.data.list });
    });
  };

  getEquipmentType = () => {
    // let url = `${API.equipmentLookups}?lookupType=equipmenttype`;
    let url = `${API.equipmentLookups}?lookupType=${"EquipmentCategoryType"}`;
    axios.get(url).then((response) => {
      this.setState({ equipemntConfigTypeList: response.data });
    });
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    if (nodeName === "AddEquipmentyes") {
      this.state.equipmentinfo.isAddOnEquipment = true;
      this.setState({
        AddEquipmentYes: true,
        AddEquipmentNo: false,
      });
    } else if (nodeName === "AddEquipmentno") {
      this.state.equipmentinfo.isAddOnEquipment = false;
      this.setState({
        AddEquipmentYes: false,
        AddEquipmentNo: true,
      });
    } else if (nodeName == "equipmentCategoryTypeid") {
      this.state.equipmentinfo.equipmentCategoryTypeid = parseInt(e.target.value);
      this.setState({});
    } else {
      this.state.equipmentinfo[nodeName] = e.target.value;
      this.setState({});
    }
  }

  SubmitData() {
    const { dispatch, t } = this.props;
    const { selectedServiceTypes, equipmentinfo } = this.state;
    /* equipmentinfo.serviceTypes = selectedServiceTypes.join(",");
    this.setState({}); */
    if (this.state.equipmentinfo.equipmentName !== "" && this.state.equipmentinfo?.equipmentCategoryTypeid > 0 && this.state.equipmentinfo.capacity !== "" && this.state.equipmentinfo.equipmentType!==""  && this.state.equipmentinfo.equipmentType !== null &&this.state.equipmentinfo.category!=="" && this.state.equipmentinfo.category !== null &&this.state.ApplicableServicesList.length > 0) {
      let data = {
        equipmentId: 0,
        equipmentName: this.state.equipmentinfo.equipmentName,
        equipmentType: this.state.equipmentinfo.equipmentType ? this.state.equipmentinfo.equipmentType : "",
        category: this.state.equipmentinfo.category ? this.state.equipmentinfo.category : "",
        capacity: this.state.equipmentinfo.capacity ? this.state.equipmentinfo.capacity : ""
      }
      let url1 = `${API.equipmentExist}`;
      axios
        .post(url1, data)
        .then((response) => {
          if (response.data === true) {
            var objectequip = {
              equipmentName: this.state.equipmentinfo.equipmentName ?? "",
              equipmentType: this.state.equipmentinfo.equipmentType ?? "",
              category: this.state.equipmentinfo.category ?? "",
              capacity: this.state.equipmentinfo.capacity ?? "",
              attachmentName: this.state.equipmentinfo.attachmentName ?? "",
              isAddOnEquipment: this.state.equipmentinfo.isAddOnEquipment ?? false,
              createdBy: this.state.equipmentinfo.createdBy ?? "",
              createdDate: this.state.equipmentinfo.createdDate ?? "",
              files: this.state.equipmentinfo.files ?? {},
              attachmentType: "",
              attachmentGuid: "",
              guideAttachmentName: "",
              guideAttachmentGuid: "",
              otherAttachmentName: "",
              otherAttachmentGuid: "",
              equipmentCategoryTypeid: this.state.equipmentinfo.equipmentCategoryTypeid ?? 0,
            };
            let url = `${API.postEquipment}`;
            axios
              .post(url, objectequip)
              .then((response) => {
                if (response.data) {
                  let data = {
                    equipmentId: response.data,
                    equipmentApplicableService:
                      this.state.ApplicableServicesList,
                    createdBy: currentuser.email,
                  };
                  let url1 = `${API.getEquipmentApplicableServices}`;
                  axios
                    .post(url1, data)
                    .then((res) => {
                      if (fileDatas.length > 0) {
                        this.props.dispatch(deleteAttachmentInBucket(fileDatas));
                        fileDatas = [];
                      }
                      dispatch(getEquipmentList(searchData));
                      this.moveClientList();
                      toast.success(`${t("CommonText.CommonAdd")}`, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                      });
                      dispatch({
                        type: "postEquipmentApplicableServiceSuccess",
                        data: res.data,
                      });
                    })
                    .catch((error) => {
                      // swal("Error!", "Something went wrong. Please try again.", "warning");
                      swal({
                        title: t('SwalError.ErrorTitle'), 
                        text: t("CommonText.500ErrorMessage"),  
                        icon: 'warning',  
                        buttons: {
                          confirm: {
                            text: t('confirmAlertMessage.Ok')
                          }
                        }
                      });
                      dispatch({
                        type: "postEquipmentApplicableServiceFailure",
                        error: "ERROR",
                      });
                    });
                }
                dispatch({
                  type: "postEquipmentDetailSuccess",
                  data: response.data,
                });
              })
              .catch((error) => {
                swal({
                  title: t('SwalError.ErrorTitle'), 
                  text: t("CommonText.500ErrorMessage"),  
                  icon: 'warning',  
                  buttons: {
                    confirm: {
                      text: t('confirmAlertMessage.Ok')
                    }
                  }
                });
                dispatch({
                  type: "postEquipmentDetailFailure",
                  error: "ERROR",
                });
              });
          } else if (response.data === false) {
            swal({
              title: t('SwalError.ErrorTitle'), 
              text: t('SwalError.EquipmentExist'),  
              icon: 'warning',  
              buttons: {
                confirm: {
                  text: t('confirmAlertMessage.Ok')
                }
              }
            });

          }
          dispatch({
            type: "getEquipmentExistListSuccess",
            data: response.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: "getEquipmentExistListFailure",
            data: "error",
          });
        });
    }
    else {
      if (this.state.equipmentinfo.equipmentName === "") {
        // swal("Error!", "Equipment name is mandatory.", "warning");
        swal({
          title: t('SwalError.ErrorTitle'), 
          text: t("SwalError.EquipmentMandatory"),  
          icon: 'warning',  
          buttons: {
            confirm: {
              text: t('confirmAlertMessage.Ok')
            }
          }
        });
      } else if (this.state.equipmentinfo?.equipmentCategoryTypeid <= 0) {
        // swal("Error!", "Equipment Contract type is mandatory.", "warning");
        swal({
          title: t('SwalError.ErrorTitle'), 
          text: t("SwalError.EquipmentContract"),  
          icon: 'warning',  
          buttons: {
            confirm: {
              text: t('confirmAlertMessage.Ok')
            }
          }
        });
      }
      else if (this.state.equipmentinfo.capacity === "") {
        // swal("Error!", "Equipment Capacity / Size is mandatory.", "warning");
        swal({
          title: t('SwalError.ErrorTitle'), 
          text: t("SwalError.EquipmentCapacity"),  
          icon: 'warning',  
          buttons: {
            confirm: {
              text: t('confirmAlertMessage.Ok')
            }
          }
        });
      }
      else if (this.state.equipmentinfo.equipmentType === "" || this.state.equipmentinfo.equipmentType == null) {
        swal({
          title: t('SwalError.ErrorTitle'), 
          text: t("SwalError.EquipmentType"),  
          icon: 'warning',  
          buttons: {
            confirm: {
              text: t('confirmAlertMessage.Ok')
            }
          }
        });
      }
      else if (this.state.equipmentinfo.category === "" || this.state.equipmentinfo.category == null) {
        swal({
          title: t('SwalError.ErrorTitle'), 
          text: t("SwalError.EquipmentCategory"),  
          icon: 'warning',  
          buttons: {
            confirm: {
              text: t('confirmAlertMessage.Ok')
            }
          }
        });
      }
      else if (this.state.ApplicableServicesList.length === 0) {
        swal({
          title: t('SwalError.ErrorTitle'), 
          text: t("SwalError.EquipmentMake"),  
          icon: 'warning',  
          buttons: {
            confirm: {
              text: t('confirmAlertMessage.Ok')
            }
          }
        });
      }
    }
  }

  onSelectChange = (item) => {
    this.setState({ selectedServiceTypes: item });
  };

  onRemoveChange(item) {
    this.setState({ selectedServiceTypes: item });
  }
  handleInputChangeMultipleFile(e, index) {
    const { dispatch } = this.props;
    let nodeName = e.target.name;
    // dispatch(postAnnualCertificate(e.target.files[0], index));

    if (nodeName === "attachmentName") {
      let filename = e.target.files[0].name;
      let regex = /^[0-9a-zA-Z\s\(\)\.\_\&\$\#\-\']+$/g;
      if (regex.test(filename)) {
        this.state.equipmentinfo[nodeName] = e.target.files[0].name;
        this.state.equipmentinfo.files = e.target.files[0];
        this.setState({});
        this.props.dispatch(AddAttachment(e.target.files[0]));
      }
      else {
        swal(
          "Error!",
          "Please upload the file without special characters.",
          "warning");
        return;
      }
    } else if (nodeName === "guideAttachmentName") {
      let filename = e.target.files[0].name;
      let regex = /^[0-9a-zA-Z\s\(\)\.\_\&\$\#\-\']+$/g;
      if (regex.test(filename)) {
        this.state.equipmentinfo[nodeName] = e.target.files[0].name;
        this.state.equipmentinfo.files = e.target.files[0];
        this.setState({});
        this.props.dispatch(AddGAttachment(e.target.files[0]));
      } else {
        swal(
          "Error!",
          "Please upload the file without special characters.",
          "warning");
        return;
      }
    }
    else if (nodeName === "documentname") {
      let filename = e.target.files[0].name;
      let regex = /^[0-9a-zA-Z\s\(\)\.\_\&\$\#\-\']+$/g;
      if (regex.test(filename)) {
        this.state.equipmentinfo[nodeName] = e.target.files[0].name;
        this.state.files = e.target.files[0];
        this.setState({});
        this.props.dispatch(AddnewdocAttachmnt(e.target.files[0]));
      } else {
        swal(
          "Error!",
          "Please upload the file without special characters.",
          "warning");
        return;
      }
    } else if (nodeName === "otherAttachmentName") {
      let filename = e.target.files[0].name;
      let regex = /^[0-9a-zA-Z\s\(\)\.\_\&\$\#\-\']+$/g;
      if (regex.test(filename)) {
        this.state.equipmentinfo[nodeName] = e.target.files[0].name;
        this.state.equipmentinfo.files = e.target.files[0];
        this.setState({});
        this.props.dispatch(AddEquipManualAttachment(e.target.files[0]));
      }
      else {
        swal(
          "Error!",
          "Please upload the file without special characters.",
          "warning");
        return;
      }
    }
  }
  ClearInput = (e) => {
    if (e === 1) {
      //this.props.dispatch(deleteAttachmentInBucket(this.state.equipmentinfo.attachmentGuid,this.state.equipmentinfo.attachmentName));
      let obj1 = {
        filename: this.state.equipmentinfo.attachmentName,
        guid: this.state.equipmentinfo.attachmentGuid,
      }
      fileDatas.push(obj1);
      this.state.equipmentinfo.attachmentName = "";
      this.state.equipmentinfo.attachmentGuid = "";
      this.props.dispatch({
        type: "AttchmentUploaded",
        data: "",
      });
    }
    if (e === 2) {
      let obj2 = {
        filename: this.state.equipmentinfo.guideAttachmentName,
        guid: this.state.equipmentinfo.guideAttachmentGuid,
      }
      fileDatas.push(obj2);
      //this.props.dispatch(deleteAttachmentInBucket(this.state.equipmentinfo.guideAttachmentGuid,this.state.equipmentinfo.guideAttachmentName));
      this.state.equipmentinfo.guideAttachmentName = "";
      this.state.equipmentinfo.guideAttachmentGuid = "";
      this.props.dispatch({
        type: "GAttchmentUploaded",
        data: "",
      });
    }
    if (e === 3) {
      let obj3 = {
        filename: this.state.equipmentinfo.otherAttachmentName,
        guid: this.state.equipmentinfo.otherAttachmentGuid,
      }
      fileDatas.push(obj3);
      //this.props.dispatch(deleteAttachmentInBucket(this.state.equipmentinfo.guideAttachmentGuid,this.state.equipmentinfo.guideAttachmentName));
      this.state.equipmentinfo.otherAttachmentName = "";
      this.state.equipmentinfo.otherAttachmentGuid = "";
      this.props.dispatch({
        type: "EquipManualAttchmentUploaded",
        data: "",
      });
    }
    this.state.equipmentinfo.files = "";
    this.setState({});
  };
  renderEquipmentTitle(state, val) {
    return state?.name?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
  }
  handleSelectChange(value, field, item) {
    const { dispatch } = this.props;
    this.state.MakeAndModelDetails.makeId = item;
    this.state.MakeAndModelDetails.makeName = value;
    this.setState({});
    dispatch(getModelsList(value));

    this.showModal(0, true, 0, "");
  }
  handleInputChanges(e, field) {
    this.state.MakeAndModelDetails[field] = e.target.value;
    this.setState({});
  }
  showModal = (ModelId, isModelNew, MakeId, MakeName, ModelType, index) => {
    const { dispatch } = this.props;
    if (!isModelNew) {
      dispatch(getModelsList(MakeName));
    }
    var arrayStroage = this.state.ApplicableServicesList;
    var arrayLength = arrayStroage.length;
    if (ModelId > 0) {
      let response = this.state.ApplicableServicesList.filter(
        (item) => item.Id === ModelId && item.makeId === MakeId
      );
      let editModelDetails = response[0];
      this.setState(
        {
          modalIsOpen: !this.state.modalIsOpen,
          isModelNew: isModelNew,
          MakeAndModelDetails: {
            Id: parseInt(editModelDetails.Id),
            makeId: editModelDetails.makeId,
            makeName: editModelDetails.makeName,
            modelId: editModelDetails.modelId,
            modelName: editModelDetails.modelName,
            serviceType: editModelDetails.serviceType,
            serviceTypeId: editModelDetails.serviceTypeId,
            radioButton: editModelDetails.isShore ? "Shore" : "Ship",
            isShore: editModelDetails.isShore,
            isDeleted: false,
          },
          equipmentinfo: {
            ...this.state.equipmentinfo,
            selectedFilesOtherAttachmentName: this.state.applicableservicesdoc[index].equipfile,
            selectedFilesAttachmentName: this.state.applicableservicesdoc[index].workfile,
            selectedFilesGuideAttachmentName: this.state.applicableservicesdoc[index].guidelinefile
          }
        },
        () => console.log(this.state.isModelNew)
      );
    } else {
      this.setState(
        {
          isModelNew: isModelNew,
          MakeAndModelDetails: {
            Id: arrayLength >= 0 ? arrayLength + 1 : 0,
            makeId: this.state.MakeAndModelDetails.makeId,
            makeName: this.state.MakeAndModelDetails.makeName,
            modelId: 0,
            modelName: "",
            serviceType: "",
            serviceTypeId: 0,
            radioButton: "",
            isShore: false,
            isDeleted: false,
          },
          modalIsOpen: !this.state.modalIsOpen,
        },
        () => {
          console.log("addservice", this.state.MakeAndModelDetails);
          console.log("model", this.state.modalIsOpen);
          if (ModelType === "closemodal") {
            this.ClearModelData();
          } else {
            this.ClearModel();
          }
        }
      );
    }
  };

  ModelValidation = () => {
    const { t } = this.props;
    if (
      $("#ModelCode").val() === "" ||
      $("#ServiceCode").val() === "" ||
      this.state.MakeAndModelDetails.radioButton === ""
    ) {
      if ($("#ModelCode").val() === "") {
        $("#ModelCodeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`);
      } else {
        $("#ModelCodeErrMsg").text("");
      }
      if ($("#ServiceCode").val() === "") {
        $("#ServiceCodeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`);
      } else {
        $("#ServiceCodeErrMsg").text("");
      }
      if (this.state.MakeAndModelDetails.radioButton === "") {
        $("#TypeCodeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`);
      } else {
        $("#TypeCodeErrMsg").text("");
      }
      return;
    } else {
      $("#ModelCodeErrMsg").text("");
      $("#ServiceCodeErrMsg").text("");
      $("#TypeCodeErrMsg").text("");
    }
    this.UploadModel();
  };
  onTypeChange = (event, values) => {
    this.state.equipmentinfo.equipmentType = values;
    this.setState({});
  };
  onCategoryChange = (event, values) => {
    this.state.equipmentinfo.category = values;
    this.setState({});
  };

  uploadFiles = async (files) => {
    const url = `${API.AttachmentAPI}`;
    const successfulUploads = [];
    for (const file of files) {
      const formData = new FormData();
      formData.append('file', file);
      try {
        const response = await axios.post(url, formData);
        const { Guid, FileName } = response.data;
        successfulUploads.push({ guid: Guid, filename: FileName });
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    }
    return successfulUploads;
  };

  checkdocvalid = (product, id, list) => {
    const matchingObject = list.find(obj => obj.Id === id);
    let flag = true;
    // if (matchingObject && Object.keys(matchingObject).length > 0) {
    //   if (matchingObject.equipmentManual.length !== product.equipfile.length ||
    //     matchingObject.workProcedure.length !== product.workfile.length ||
    //     matchingObject.guideLines.length !== product.guidelinefile.length
    //   ) {
    //     flag = true;
    //   }
    // }

    if (matchingObject && Object.keys(matchingObject).length > 0) {
      // if ((matchingObject.equipmentManual.length !== product.equipmentManual.length &&
      //   matchingObject.workProcedure.length !== product.workProcedure.length &&
      //   matchingObject.guideLines.length !== product.guideLines.length)
      // ) {
      if (this.compareArrays(matchingObject.equipmentManual, product.equipmentManual) &&
        this.compareArrays(matchingObject.workProcedure, product.workProcedure) &&
        this.compareArrays(matchingObject.guideLines, product.guideLines)) {
        flag = false;
      }
    }
    // }
    return flag;
  }


  compareArrays(arr1, arr2) {
    // Check if both arrays have the same length
    if (arr1.length !== arr2.length) {
      return false;
    }

    // Sort both arrays by a common property (e.g., 'filename' or 'guid') for accurate comparison
    const sortedArr1 = [...arr1].sort((a, b) => a.filename.localeCompare(b.filename));
    const sortedArr2 = [...arr2].sort((a, b) => a.filename.localeCompare(b.filename));

    // Compare each object in both arrays
    for (let i = 0; i < sortedArr1.length; i++) {
      const obj1 = sortedArr1[i];
      const obj2 = sortedArr2[i];

      // Check if filename and guid match
      if (obj1.filename !== obj2.filename) {
        return false; // If any property doesn't match, arrays are not the same
      }
    }

    // If no mismatch found, arrays are the same
    return true;
  }

  UploadModel = async () => {
    const { dispatch } = this.props;
    var equipmentManualguid = await this.uploadFiles(this.state.equipmentinfo.selectedFilesOtherAttachmentName);
    var workguid = await this.uploadFiles(this.state.equipmentinfo.selectedFilesAttachmentName);
    var guideid = await this.uploadFiles(this.state.equipmentinfo.selectedFilesGuideAttachmentName);
    var product = {
      Id: parseInt(this.state.MakeAndModelDetails.Id),
      makeId: parseInt(this.state.MakeAndModelDetails.makeId),
      makeName: this.state.MakeAndModelDetails.makeName,
      modelId: parseInt(this.state.MakeAndModelDetails.modelId),
      modelName: this.state.MakeAndModelDetails.modelName,
      serviceTypeId: parseInt(this.state.MakeAndModelDetails.serviceTypeId),
      serviceType: this.state.MakeAndModelDetails.serviceType,
      isShore: this.state.MakeAndModelDetails.isShore,
      radioButton: this.state.MakeAndModelDetails.radioButton,
      isDeleted: this.state.MakeAndModelDetails.isDeleted,
      equipmentManual: equipmentManualguid,
      workProcedure: workguid,
      guideLines: guideid
    };
    var productfile = {
      equipfile: this.state.equipmentinfo.selectedFilesOtherAttachmentName,
      workfile: this.state.equipmentinfo.selectedFilesAttachmentName,
      guidelinefile: this.state.equipmentinfo.selectedFilesGuideAttachmentName
    }

    var booldoc = this.checkdocvalid(product, product.Id, this.state.ApplicableServicesList);
    console.log(product);
    let GetModel = this.state.ApplicableServicesList;
    let Getmodelfile = this.state.applicableservicesdoc;
    let temp = GetModel.filter((j) => j.Id === product.Id) || [];
    if (temp.length > 0) {
      let servicedata = GetModel.filter((k) => (k.serviceTypeId === product.serviceTypeId) && (k.makeId === product.makeId) && (k.modelId === product.modelId) && (k.radioButton === product.radioButton))
      console.log(servicedata)
      if (servicedata.length > 0 && !booldoc) {
        console.log(this.state.openEquipment)
        var str = "Make,Model,Service type and Service year";
        swal(
          "Error!",
          str +
          " already exist. Please change the" + " " +
          str.toLocaleLowerCase() + " " + ".",
          "warning"
        );
      } else {
        GetModel.forEach((ele, index) => {
          if (ele.Id === product.Id) {
            GetModel[index] = product;
            Getmodelfile[index] = productfile;
          }
        });
      }
    } else {
      let servicedata = GetModel.filter((k) => (k.serviceTypeId === product.serviceTypeId) && (k.makeId === product.makeId) && (k.modelId === product.modelId))
      console.log(servicedata)
      if (servicedata.length > 0) {
        console.log(this.state.openEquipment)
        var str = "Make,Model,Service year and Service type";
        swal(
          "Error!",
          str +
          " already exist. Please change the" + " " +
          str.toLocaleLowerCase() + " " + ".",
          "warning"
        );

      } else {
        GetModel.push(product);
        Getmodelfile.push(productfile);
      }
    }
    var Information = JSON.stringify(GetModel);
    dispatch({
      type: "MakeAndModelApplicableServices",
      data: GetModel,
    });
    this.state.MakeAndModelDetails.makeName = "";
    this.setState(
      {
        ApplicableServicesList: GetModel,
        applicableservicesdoc: Getmodelfile,
        modalIsOpen: false,
      },
      () => {
        this.ClearModel();
      }
    );
  };
  ClearModel = () => {
    var arrayStroage = this.state.ApplicableServicesList;
    var arrayLength = arrayStroage.length;
    this.setState({
      MakeAndModelDetails: {
        Id: arrayLength >= 0 ? arrayLength + 1 : 0,
        serviceTypeId: 0,
        makeId: this.state.MakeAndModelDetails.makeId,
        makeName: this.state.MakeAndModelDetails.makeName,
        modelId: 0,
        modelName: "",
        isShore: false,
        radioButton: "",
        isDeleted: false,
      },
    });
    this.setState((prevState) => ({
      equipmentinfo: {
        ...prevState.equipmentinfo,
        selectedFilesAttachmentName: [],
        selectedFilesGuideAttachmentName: [],
        selectedFilesOtherAttachmentName: [],
      },
    }));
  };
  ClearModelData = () => {
    var arrayStroage = this.state.ApplicableServicesList;
    var arrayLength = arrayStroage.length;
    this.setState({
      MakeAndModelDetails: {
        Id: arrayLength >= 0 ? arrayLength + 1 : 0,
        serviceTypeId: 0,
        makeId: 0,
        makeName: "",
        modelId: 0,
        modelName: "",
        isShore: false,
        radioButton: "",
        isDeleted: false,
      },
    });
  };
  handleRadioButtonChanges = (e, i) => {
    var lineitems = this.state.MakeAndModelDetails;
    lineitems[e.target.name] = e.target.value;
    if (e.target.value === "Shore") {
      lineitems["isShore"] = true;
    } else {
      lineitems["isShore"] = false;
    }
    this.setState({});
  };
  handleSelectYear = (e, i) => {
    if (e.target.name === "modelId") {
      var value = this.props.ModelList.filter(
        (key) => key.id === parseInt(e.target.value)
      );
      this.state.MakeAndModelDetails.modelId = value[0].id;
      this.state.MakeAndModelDetails.modelName = value[0].name;
      this.setState({});
    }
    if (e.target.name === "serviceTypeId") {
      var value = this.props.applicableServiceTypeList.filter(
        (key) => key.item === parseInt(e.target.value)
      );
      this.state.MakeAndModelDetails.serviceTypeId = value[0].item;
      this.state.MakeAndModelDetails.serviceType = value[0].serviceTypes;
      this.setState({});
    }
  };

  deleteModel = (index) => {
    const { t } = this.props;
    this.state.openEquipment = true;
    this.setState({})
    confirmAlert({
      message: `${t("confirmAlertMessage.DeleteMsg")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            const models = [...this.state.ApplicableServicesList];
            const models1 = [...this.state.applicableservicesdoc];
            models.splice(index, 1);
            models1.splice(index, 1);
            this.setState({ ApplicableServicesList: models, applicableservicesdoc: models1, openEquipment: false });
          },
        },
        {
          label: `${t("confirmAlertMessage.No")}`,
          onClick: () => {
            this.state.openEquipment = false;
            this.setState({})
          },
        },
      ],
    });
  };

  handleDropFiles = (num, acceptedFiles) => {
    if (num === 1) {
      this.setState((prevState) => ({
        equipmentinfo: {
          ...prevState.equipmentinfo,
          selectedFilesOtherAttachmentName: [
            ...prevState.equipmentinfo.selectedFilesOtherAttachmentName,
            ...acceptedFiles,
          ],
        },
        // keydrop1: Date.now()
      }), () => { console.log(this.state.equipmentinfo.selectedFilesOtherAttachmentName) });

      // this.setState({
      //   equipmentinfo:{
      //     ...this.state.equipmentinfo,
      //     selectedFilesOtherAttachmentName:acceptedFiles
      //   }
      // })

    }

    else if (num === 2) {
      this.setState((prevState) => ({
        equipmentinfo: {
          ...prevState.equipmentinfo,
          selectedFilesAttachmentName: [
            ...prevState.equipmentinfo.selectedFilesAttachmentName,
            ...acceptedFiles,
          ],
        },
        // keydrop2: Date.now()
      }));
      // this.setState({
      //   equipmentinfo:{
      //     ...this.state.equipmentinfo,
      //     selectedFilesAttachmentName:acceptedFiles
      //   }
      // })
    }

    else if (num === 3) {
      this.setState((prevState) => ({
        equipmentinfo: {
          ...prevState.equipmentinfo,
          selectedFilesGuideAttachmentName: [
            ...prevState.equipmentinfo.selectedFilesGuideAttachmentName,
            ...acceptedFiles,
          ],
        },
        // keydrop3: Date.now()
      }));
    }
    //   this.setState({
    //     equipmentinfo:{
    //       ...this.state.equipmentinfo,
    //       selectedFilesGuideAttachmentName:acceptedFiles
    //     }
    //   })
    //  }

  };


  ClearFiles = (num) => {
    if (num === 3) {
      this.setState(prevState => ({
        equipmentinfo:
        {
          ...prevState.equipmentinfo,
          selectedFilesGuideAttachmentName: []
        }
      }))
    }

    else if (num === 2) {
      this.setState(prevState => ({
        equipmentinfo:
        {
          ...prevState.equipmentinfo,
          selectedFilesAttachmentName: []
        }
      }))
    }

    //   else if(num===1){
    //     this.setState(prevState=>({equipmentinfo:
    //       { ...prevState.equipmentinfo,
    //         selectedFilesOtherAttachmentName:[]}
    //     }))
    //     console.log(this.state.equipmentinfo.selectedFilesOtherAttachmentName,'check')
    //   }
    // }
    else if (num === 1) {
      this.setState(prevState => {
        const updatedFiles = [];


        console.log(updatedFiles, 'checkdel');

        return {
          equipmentinfo: {
            ...prevState.equipmentinfo,
            selectedFilesOtherAttachmentName: updatedFiles,
          },
        };
      });
    }
  }


  ClearInput = (e) => {
    if (e === 1) {
      let obj1 = {
        filename: this.state.equipmentinfo.attachmentName,
        guid: this.state.equipmentinfo.attachmentGuid,
      }
      console.log(fileDatas);
      fileDatas.push(obj1);
      //this.props.dispatch(deleteAttachmentInBucket(this.state.equipmentinfo.attachmentGuid,this.state.equipmentinfo.attachmentName));
      this.state.equipmentinfo.attachmentName = "";
      this.state.equipmentinfo.files = "";
      this.state.equipmentinfo.attachmentGuid = "";
      this.props.dispatch({
        type: "AttchmentUploaded",
        data: "",
      });
      this.setState(prevState => ({
        equipmentinfo:
        {
          ...prevState.equipmentinfo,
          selectedFilesAttachmentName: []
        }
      }))
    }
    if (e === 2) {
      let obj2 = {
        filename: this.state.equipmentinfo.guideAttachmentName,
        guid: this.state.equipmentinfo.guideAttachmentGuid,
      }
      console.log(fileDatas);
      fileDatas.push(obj2);
      //this.props.dispatch(deleteAttachmentInBucket(this.state.equipmentinfo.guideAttachmentGuid,this.state.equipmentinfo.guideAttachmentName));
      this.state.equipmentinfo.guideAttachmentName = "";
      this.state.equipmentinfo.files = "";
      this.state.equipmentinfo.guideAttachmentGuid = "";
      this.props.dispatch({
        type: "GAttchmentUploaded",
        data: "",
      });
      this.setState(prevState => ({
        equipmentinfo:
        {
          ...prevState.equipmentinfo,
          selectedFilesGuideAttachmentName: []
        }
      }))

    }
    if (e === 3) {
      let obj3 = {
        filename: this.state.equipmentinfo.otherAttachmentName,
        guid: this.state.equipmentinfo.otherAttachmentGuid,
      }
      fileDatas.push(obj3);
      this.state.equipmentinfo.otherAttachmentName = "";
      this.state.equipmentinfo.otherAttachmentGuid = "";
      this.props.dispatch({
        type: "EquipManualAttchmentUploaded",
        data: "",
      });
      this.setState(prevState => ({
        equipmentinfo:
        {
          ...prevState.equipmentinfo,
          selectedFilesOtherAttachmentName: []
        }
      }))
    }
  };

  toDeleteGuideFile(idnum) {
    this.setState((prevState) => {
      const updatedFiles = prevState.equipmentinfo.selectedFilesGuideAttachmentName.filter((_, index) => index !== idnum);

      // Log the updated state here to see the change
      console.log(updatedFiles, 'delete');

      return {
        equipmentinfo: {
          ...prevState.equipmentinfo,
          selectedFilesGuideAttachmentName: updatedFiles,
        },
        keydrop3: Date.now()
      };
    });
  }

  toDeleteOtherFile(idnum) {
    this.setState((prevState) => ({
      equipmentinfo: {
        ...prevState.equipmentinfo,
        selectedFilesOtherAttachmentName: prevState.equipmentinfo.selectedFilesOtherAttachmentName.filter((_, index) => (index !== idnum))
      },
      keydrop1: Date.now()
    }))
    console.log(this.state.equipmentinfo.selectedFilesOtherAttachmentName, 'check')
  }

  toDeleteAttachmentFile(idnum) {
    this.setState((prevState) => ({
      equipmentinfo: {
        ...prevState.equipmentinfo,
        selectedFilesAttachmentName: prevState.equipmentinfo.selectedFilesAttachmentName.filter((_, index) => (index !== idnum))
      },
      keydrop2: Date.now()
    }))
  }
  render() {
    const { ModelList, applicableServiceTypeList, t, Loading } = this.props;

    return (
      <div className="pb-3">
        <Modal
          size="xl"
          show={this.state.modalIsOpen}
          onHide={() => {
            this.showModal(0, true, 0, "", "closemodal");
          }}
          aria-labelledby="example-modal-sizes-title-sm"
          backdrop="static"
          centered="true"
          animation="true"
          className="borderCondition"
        >
          <Modal.Header
            className="ClosebtnColor"
            closeButton
            style={{ backgroundColor: "#1a3464", color: "white" }}
          >
            <Modal.Title id="example-modal-sizes-title-sm">
              {t("content.Servicetype")}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="row">
              <div className={"col-lg-4"}>
                <label className="form-label required">{t("ShipEquipmentStatusScreen.Model")}</label>
                <br></br>
                <select
                  className="form-control"
                  id="ModelCode"
                  name="modelId"
                  value={this.state.MakeAndModelDetails.modelId}
                  onChange={(e) => this.handleSelectYear(e)}
                >
                  <option value="">{t("MakeAndModelScreen.SelectModel")}</option>
                  {ModelList?.map((item, index) => (
                    <option value={item.id}>{item.name}</option>
                  ))}
                </select>
                <span id="ModelCodeErrMsg" className="spanErrMsg"></span>
              </div>
              <div className={"col-lg-4"}>
                <label className="form-label required">{t("content.Servicetype")}</label>
                <br></br>
                <select
                  className="form-control"
                  name="serviceTypeId"
                  value={this.state.MakeAndModelDetails.serviceTypeId}
                  id="ServiceCode"
                  onChange={(e) => this.handleSelectYear(e)}
                >
                  <option value="">{t("EquipmentManagementScreenContent.SelectServiceType")}</option>
                  {applicableServiceTypeList?.map((name) => (
                    <option value={name.item}>{name.serviceTypes}</option>
                  ))}
                </select>
                <span id="ServiceCodeErrMsg" className="spanErrMsg"></span>
              </div>
              <div className={"col-lg-4"}>
                <label className="form-label required">{t("ShipEquipmentStatusScreen.Type")}</label>
                <br></br>
                <div className="mr-1">
                  <RadioGroup
                    className="radio-value"
                    row
                    name="radioButton"
                    id="TypeCode"
                    value={this.state.MakeAndModelDetails.radioButton}
                    onChange={(e) => this.handleRadioButtonChanges(e)}
                  >
                    <FormControlLabel
                      className="mt-0"
                      value="Ship"
                      control={<Radio color="default" size="small" />}
                      label={t("Generateservicerequestcontent.Ship")}
                    />
                    <FormControlLabel
                      className="mt-0"
                      value="Shore"
                      control={<Radio color="default" size="small" />}
                      label={t("Generateservicerequestcontent.Shore")}
                    />
                  </RadioGroup>
                  <span id="TypeCodeErrMsg" className="spanErrMsg"></span>
                </div>
              </div>

            </div>

            <div className="row">
              <div className="col-lg-4">
                <label className="form-label">{t("EquipmentManagementScreenContent.EquipmentManual")}</label>
                <br></br>
                <div class="input-group ">
                  <div class="input-group-prepend">
                    {/* <span class="input-group-text">
                              {t("CommonText.BrowseFile")}
                              <input
                                type="file"
                                multiple
                                style={{ marginRight: 40 }}
                                name="otherAttachmentName"
                                onChange={(e) =>
                                  this.handleInputChangeMultipleFile(e)
                                }
                                onClick={(event) => {
                                  event.currentTarget.value = null;
                                }}
                              />
                            </span> */}
                    <div style={{ display: "flex", position: "relative" }}>
                      <Folder className="folderIcon" />
                      <DropzoneArea
                        key={this.state.keydrop1}
                        id="selectedFilesOtherAttachmentName"
                        onDrop={(files) => this.handleDropFiles(1, files)}
                        showPreviewsInDropzone={false}
                        maxFileSize={10000000}
                        dropzoneText={t('CommonText.UploadText')}
                        filesLimit={10}
                        style={{ height: '20px' }}
                        sx={{

                          '& .MuiDropzonePreviewList-root': {
                            display: 'none',
                          },
                          '& .MuiDropzoneArea-root': {
                            minHeight: '20px !important',
                          },

                        }}
                      />
                    </div>
                    {/* <input
                            multiple
                            type="text"
                            class="form-control"
                            placeholder=""
                            value={this.state.equipmentinfo.selectedFilesOtherAttachmentName.length !==0?(
                              this.state.equipmentinfo.selectedFilesOtherAttachmentName.length + " Files" ):( " ")
                            }
                          /> */}
                  </div>

                  {/* {this.state.equipmentinfo.otherAttachmentName ? (
                            <div
                              class="input-group-append"
                              style={{ cursor: "pointer" }}
                            >
                              <i
                                class="fa fa-times input-group-text padding-top-9px"
                                aria-hidden="true"
                                onClick={() => this.ClearInput(3)}
                              ></i>
                            </div>
                          ) : (
                            ""
                          )} */}
                </div>
                <div>
                  <span className="removeall" onClick={() => this.ClearFiles(1)}>{t("EquipmentManagementScreenContent.RemoveAll")}</span>
                </div>
                <span id="selectedFilesOtherAttachmentNameErr" className="spanErrMsg"></span>
                <div className={"displaybox"}>
                  <br></br>
                  <table style={{ border: 'none' }}>

                    <tbody>
                      {this.state.equipmentinfo.selectedFilesOtherAttachmentName.map((fileName, index) => (

                        <tr key={index} ><td><FileCopy className="filecopy" /></td><td>{fileName.name}</td> <td><Close className="equipcloseicon" onClick={() => this.toDeleteOtherFile(index)} /></td> </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="col-lg-4">
                <label className="form-label">{t("EquipmentManagementScreenContent.Workprocedure")}</label>
                <br></br>
                <div class="input-group ">
                  <div class="input-group-prepend">
                    {/* <span class="input-group-text">
                              {t("CommonText.BrowseFile")}
                              <input
                                
                                type="file"
                                multiple
                                id="files"
                                style={{ marginRight: 40 }}
                                name="attachmentName"
                                onChange={(e) =>
                                  this.handleInputChangeMultipleFile(e)
                                }
                                onClick={(event) => {
                                  event.currentTarget.value = null;
                                }}
                              />
                            </span> */}
                    <div style={{ display: "flex", position: "relative" }}>
                      <Folder className="folderIcon" />
                      <DropzoneArea
                        key={this.state.keydrop2}
                        id="selectedFilesAttachmentName"
                        onDrop={(files) => this.handleDropFiles(2, files)}
                        showPreviewsInDropzone={false}
                        maxFileSize={10000000}
                        dropzoneText={t('CommonText.UploadText')}
                        filesLimit={10}
                        style={{ height: '20px' }}
                        sx={{

                          '& .MuiDropzonePreviewList-root': {
                            display: 'none',
                          },
                          '& .MuiDropzoneArea-root': {
                            minHeight: '20px !important',
                          },
                        }}
                      />
                    </div>
                    {/* <input
                            multiple
                            type="text"
                            class="form-control"
                            placeholder=""
                            value={this.state.equipmentinfo.selectedFilesAttachmentName.length !==0?(
                                this.state.equipmentinfo.selectedFilesAttachmentName.length + " Files" ):( " ")
                            }
                          /> */}
                  </div>

                  {/* {this.state.equipmentinfo.attachmentName ? (
                            <div
                              class="input-group-append"
                              style={{ cursor: "pointer" }}
                            >
                              <i
                                class="fa fa-times input-group-text padding-top-9px"
                                aria-hidden="true"
                                onClick={() => this.ClearInput(1)}
                              ></i>
                              
                            </div>
                          ) : (
                            ""
                          )} */}
                </div>
                <div>
                  <span className="removeall" onClick={() => this.ClearFiles(2)}>{t("EquipmentManagementScreenContent.RemoveAll")}</span>
                </div>
                <span id="selectedFilesAttachmentNameErr" className="spanErrMsg"></span>
                <div className={"displaybox"}>
                  <br></br>
                  <table style={{ border: 'none' }}>
                    <tbody>
                      {this.state.equipmentinfo.selectedFilesAttachmentName.map((fileName, index) => (
                        <tr key={index} ><td><FileCopy className="filecopy" /></td><td>{fileName.name}</td> <td><Close className="equipcloseicon" onClick={() => this.toDeleteAttachmentFile(index)} /></td></tr>
                      ))}</tbody>
                  </table>
                </div>
              </div>
              <div className="col-lg-4">
                <label className="form-label">{t("EquipmentManagementScreenContent.GuideLines")}</label>
                <br></br>
                <div class="input-group">
                  <div class="input-group-prepend">
                    {/* <span class="input-group-text">
                                {t("CommonText.BrowseFile")}
                               
                                <input
                                  type="file"
                                  multiple
                                  id="files"
                                  style={{ marginRight: 40 }}
                                  name="guideAttachmentName"
                                  onChange={(e) =>
                                    this.handleInputChangeMultipleFile(e)
                                  }
                                  onClick={(event) => {
                                    event.currentTarget.value = null;
                                  }}
                                />
                              </span> */}
                    <div style={{ display: "flex", position: "relative" }}>
                      <Folder className="folderIcon" />
                      <DropzoneArea
                        key={this.state.keydrop3}
                        id="selectedFilesGuideAttachmentName"
                        onDrop={(files) => this.handleDropFiles(3, files)}
                        showPreviewsInDropzone={false}
                        maxFileSize={10000000}
                        dropzoneText={t('CommonText.UploadText')}
                        filesLimit={10}
                        style={{ height: '20px' }}
                        sx={{
                          '& .MuiDropzonePreviewList-root': {
                            display: 'none',
                          },
                          '& .MuiDropzoneArea-root': {
                            minHeight: '20px !important',
                          },
                        }}
                      />
                    </div>
                    {/* <input
                              multiple
                              type="text"
                              class="form-control"
                              placeholder=""
                              value={this.state.equipmentinfo.selectedFilesGuideAttachmentName.length !==0?(
                                this.state.equipmentinfo.selectedFilesGuideAttachmentName.length + " Files" ):( " ")
                            }
                            /> */}
                    {/* {this.state.equipmentinfo.guideAttachmentName ? (
                              <div
                                class="input-group-append"
                                style={{ cursor: "pointer" }}
                              >
                                <i
                                  class="fa fa-times input-group-text padding-top-9px"
                                  aria-hidden="true"
                                  onClick={() => this.ClearInput(2)}
                                ></i>
                              </div>
                            ) : (
                              ""
                            )} */}

                  </div>

                </div>
                <div>
                  <span className="removeall" onClick={() => this.ClearFiles(3)}>{t("EquipmentManagementScreenContent.RemoveAll")}</span>
                </div>
                <span id="selectedFilesGuideAttachmentNameErr" className="spanErrMsg"></span>
                <div className={"displaybox"}>
                  <br></br>
                  <table style={{ border: 'none' }}>
                    <tbody>
                      {this.state.equipmentinfo.selectedFilesGuideAttachmentName.map((fileName, index) => (
                        <tr key={index}><td><FileCopy className="filecopy" /></td><td>{fileName.name} </td><td><Close className="equipcloseicon" onClick={() => this.toDeleteGuideFile(index)} /></td></tr>
                      ))}</tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="row">
              {/* <div className={"col-lg-4 displaybox"}>
                <br></br>
                <table style={{ border: 'none' }}>

                  <tbody>
                    {this.state.equipmentinfo.selectedFilesOtherAttachmentName.map((fileName, index) => (

                      <tr key={index} ><td><FileCopy className="filecopy" /></td><td>{fileName.name}</td> <td><Close className="equipcloseicon" onClick={() => this.toDeleteOtherFile(index)} /></td> </tr>
                    ))}
                  </tbody>
                </table>
              </div> */}

              {/* <div className={"col-lg-4 displaybox"}>
                <br></br>
                <table style={{ border: 'none' }}>
                  <tbody>
                    {this.state.equipmentinfo.selectedFilesAttachmentName.map((fileName, index) => (
                      <tr key={index} ><td><FileCopy className="filecopy" /></td><td>{fileName.name}</td> <td><Close className="equipcloseicon" onClick={() => this.toDeleteAttachmentFile(index)} /></td></tr>
                    ))}</tbody>
                </table>
              </div> */}

              {/* <div className={"col-lg-4 displaybox"}>
                <br></br>
                <table style={{ border: 'none' }}>
                  <tbody>
                    {this.state.equipmentinfo.selectedFilesGuideAttachmentName.map((fileName, index) => (
                      <tr key={index}><td><FileCopy className="filecopy" /></td><td>{fileName.name} </td><td><Close className="equipcloseicon" onClick={() => this.toDeleteGuideFile(index)} /></td></tr>
                    ))}</tbody>
                </table>
              </div> */}

            </div>


            <div className="row">
              <div className="col-lg-6 ml-auto">
                <div
                  className="search-btn-col pt-3"
                  style={{ textAlign: "end" }}
                >
                  <button
                    type="button"
                    id="SBMCAdd"
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-2"
                    style={{ backgroundColor: "rgb(26, 52, 100)" }}
                    onClick={() => this.ModelValidation()}
                  >
                    {this.state.isModelNew ? `${t("ShipManagementContent.Add")}` : `${t("EquipmentServiceTypes.Update")}`}
                  </button>
                  <button
                    type="button"
                    className="btn btn-light text-uppercase txtside-btn txtht-btn mt-2 ml-2"
                    data-dismiss="modal"
                    onClick={() => this.showModal(0, true, 0, "", "closemodal")}
                  >
                    {t("ComplianceandBudgetScreen.Cancel")}
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {this.renderCardData()}
      </div>
    );
  }

  renderCardData() {
    const {
      showSidePane,
      EquipmentTypeList,
      CategoryList,
      serviceTypeList,
      ModelList,
      MakeList,
      Loading,
      t
    } = this.props;
    const { selectedServiceTypes } = this.state;
    return (
      <div className="full-height">
        <div className="px-4 pt-3">
          <div className="row">
            <div className="col-lg-12">
              <div className="panel-box">
                <div className="row search-filter-box">
                  <div className="col-lg-12">
                    <div
                      className="card mt-2 MM-card-header mb-0"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1a3464",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title ml-2 mt-2"
                          style={{ color: "092a51" }}
                        >
                          {t("EquipmentManagementScreenContent.BasicInformation")}
                        </h5>
                      </div>
                    </div>
                    <div className="row search-filter-box">
                      <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                        <label className="form-label fontstyle required">{t("EquipmentManagementScreenContent.Name")}</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="equipmentName"
                          placeholder={t("EquipmentManagementScreenContent.Name")}
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.equipmentinfo.equipmentName}
                        ></input>
                      </div>
                      <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                        <label className="form-label required">{t("ComplianceandBudgetScreen.Type")}</label>
                        <br></br>

                        <Autocomplete
                          value={this.state.equipmentinfo.equipmentType || ""}
                          options={this.state.EquipmentTypeList ?? []}
                          getOptionLabel={(option) => option || ""}
                          style={{ marginTop: "-17px" }}
                          noOptionsText={t("CommonText.NoOption")}
                          size={"small"}
                          onChange={(event, value) => {
                            this.onTypeChange(event, value);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder={t("EquipmentManagementScreenContent.SelectEquipmentType")}
                              margin="normal"
                            />
                          )}
                        />
                      </div>
                      <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                        <label className="form-label required">{t("TopPaneContent.Category")}</label>
                        <br></br>
                        <Autocomplete
                          value={this.state.equipmentinfo.category || ""}
                          options={this.state.CategoryTypeList ?? []}
                          getOptionLabel={(option) => option || ""}
                          style={{ marginTop: "-17px" }}
                          noOptionsText={t("CommonText.NoOption")}
                          size={"small"}
                          onChange={(e, value) =>
                            this.onCategoryChange(e, value)
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder={t("EquipmentManagementScreenContent.SelectCategory")}
                              margin="normal"
                            />
                          )}
                        />
                      </div>
                      <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                        <label className="form-label required">{t("ShipEquipmentStatusScreen.Capacity")} / {t("ShipEquipmentStatusScreen.Size")}</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="capacity"
                          placeholder={t("EquipmentManagementScreenContent.Capacity/Size")}
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.equipmentinfo.capacity}
                        ></input>
                      </div>
                      {/* <div
                        className={
                          showSidePane
                            ? "col-lg-6 hide-pic-option"
                            : "col-lg-4 hide-pic-option"
                        }
                      >
                        <label className="form-label">{t("EquipmentManagementScreenContent.EquipmentManual")}</label>
                        <br></br>
                        <div class="input-group ">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                              {t("CommonText.BrowseFile")}
                              <input
                                type="file"
                                multiple
                                id="files"
                                name="otherAttachmentName"
                                style={{ marginRight: 40 }}
                                onChange={(e) =>
                                  this.handleInputChangeMultipleFile(e)
                                }
                                onClick={(event) => {
                                  event.currentTarget.value = null;
                                }}
                              />
                            </span>
                          </div>
                          <input
                            multiple
                            type="text"
                            class="form-control"
                            placeholder=""
                            value={this.state.equipmentinfo.otherAttachmentName}
                          />
                          {this.state.equipmentinfo.otherAttachmentName ? (
                            <div
                              class="input-group-append"
                              style={{ cursor: "pointer" }}
                            >
                              <i
                                class="fa fa-times input-group-text padding-top-9px"
                                aria-hidden="true"
                                onClick={() => this.ClearInput(3)}
                              ></i>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div> */}
                      {/* <div
                        className={
                          showSidePane
                            ? "col-lg-6 hide-pic-option"
                            : "col-lg-4 hide-pic-option"
                        }
                      >
                        <label className="form-label">{t("EquipmentManagementScreenContent.Workprocedure")}</label>
                        <br></br>
                        <div class="input-group ">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                              {t("CommonText.BrowseFile")}
                              <input
                                type="file"
                                multiple
                                id="files"
                                name="attachmentName"
                                style={{ marginRight: 40 }}
                                onChange={(e) =>
                                  this.handleInputChangeMultipleFile(e)
                                }
                                onClick={(event) => {
                                  event.currentTarget.value = null;
                                }}
                              />
                            </span>
                          </div>
                          <input
                            multiple
                            type="text"
                            class="form-control"
                            placeholder=""
                            value={this.state.equipmentinfo.attachmentName}
                          />
                          {this.state.equipmentinfo.attachmentName ? (
                            <div
                              class="input-group-append"
                              style={{ cursor: "pointer" }}
                            >
                              <i
                                class="fa fa-times input-group-text padding-top-9px"
                                aria-hidden="true"
                                onClick={() => this.ClearInput(1)}
                              ></i>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      {user === Role.mmpladmin ? (
                        <div
                          className={
                            showSidePane
                              ? "col-lg-6 hide-pic-option"
                              : "col-lg-4 hide-pic-option"
                          }
                        >
                          <label className="form-label">{t("EquipmentManagementScreenContent.GuideLines")}</label>
                          <br></br>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">
                                {t("CommonText.BrowseFile")}
                                <input
                                  type="file"
                                  multiple
                                  id="files"
                                  name="guideAttachmentName"
                                  style={{ marginRight: 40 }}
                                  onChange={(e) =>
                                    this.handleInputChangeMultipleFile(e)
                                  }
                                  onClick={(event) => {
                                    event.currentTarget.value = null;
                                  }}
                                />
                              </span>
                            </div>
                            <input
                              multiple
                              type="text"
                              class="form-control"
                              placeholder=""
                              value={
                                this.state.equipmentinfo.guideAttachmentName
                              }
                            />
                            {this.state.equipmentinfo.guideAttachmentName ? (
                              <div
                                class="input-group-append"
                                style={{ cursor: "pointer" }}
                              >
                                <i
                                  class="fa fa-times input-group-text padding-top-9px"
                                  aria-hidden="true"
                                  onClick={() => this.ClearInput(2)}
                                ></i>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      ) : (
                        <></>
                      )} */}
                      {/* <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                        <label className="form-label">{t("EquipmentManagementScreenContent.AddonEquipment")} </label>
                        <br></br>
                        <div className="row">
                          <div
                            className={
                              showSidePane
                                ? "col-sm-5 clsm-3"
                                : "col-sm-3 mt-2 clsm-3"
                            }
                          >
                            <input
                              type="radio"
                              name="AddEquipmentyes"
                              checked={this.state.AddEquipmentYes}
                              onChange={(e) => this.handleInputChange(e)}
                            ></input>
                            <span className="ml-1">{t("confirmAlertMessage.Yes")}</span>
                          </div>
                          <div
                            className={
                              showSidePane
                                ? "col-sm-7 clsm-9"
                                : "col-sm-9 mt-2 clsm-9"
                            }
                          >
                            <input
                              type="radio"
                              name="AddEquipmentno"
                              checked={this.state.AddEquipmentNo}
                              onChange={(e) => this.handleInputChange(e)}
                            ></input>
                            <span className="ml-1">{t("confirmAlertMessage.No")}</span>
                          </div>
                        </div>
                      </div> */}
                      <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                        <label className="form-label required">
                          {/* {t("EquipmentTypeScreen.Title")} */}
                          {t("ShipEquipmentStatusScreen.Equipment")} {""} {t("ShipEquipmentStatusScreen.ContractType")}</label>
                        <br></br>
                        <select
                          className="form-control"
                          id="equipmentType"
                          name="equipmentCategoryTypeid"
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.equipmentinfo?.equipmentCategoryTypeid}
                        >
                          <option value="">
                            {/* {t("EquipmentManagementScreenContent.SelectEquipmentType")} */}
                            {t("content.Select")} {""} {t("ShipEquipmentStatusScreen.Equipment")} {""} {t("ShipEquipmentStatusScreen.ContractType")}
                            </option>
                          {/* <option value="1">Contract</option>
                          <option value="2">Add On</option>
                          <option value="3">Adhoc</option> */}
                          {
                            this.state.equipemntConfigTypeList?.length > 0 && this.state.equipemntConfigTypeList.map(x => {
                              return <option value={x.lookUpId}>{x.lookUpName}</option>
                            })
                          }
                        </select>
                      </div>
                      {/* <div
                        className={
                          showSidePane
                            ? "col-lg-6 hide-pic-option"
                            : "col-lg-4 hide-pic-option"
                        }
                      >
                        <label className="form-label">{'Manual'}</label>
                        <br></br>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                              {t("CommonText.BrowseFile")}
                              <input
                                type="file"
                                multiple
                                id="files"
                                style={{ marginRight: 40 }}
                                name="documentname"
                                onChange={(e) =>
                                  this.handleInputChangeMultipleFile(e)
                                }
                                onClick={(event) => {
                                  event.currentTarget.value = null;
                                }}
                              />
                            </span>
                          </div>
                          <input
                            multiple
                            type="text"
                            class="form-control"
                            placeholder=""
                            value={
                              this.state.equipmentinfo.documentname
                            }
                          />
                          {this.state.equipmentinfo.documentname ? (
                            <div
                              class="input-group-append"
                              style={{ cursor: "pointer" }}
                            >
                              <i
                                class="fa fa-times input-group-text padding-top-9px"
                                aria-hidden="true"
                                onClick={() => this.ClearInput(3)}
                              ></i>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div> */}

                    </div>

                    <div className="search-filter-box">
                      <div
                        className="card MM-card-header"
                        style={{ backgroundColor: "white" }}>
                        <div
                          className="card-body flex"
                          style={{
                            padding: "0rem",
                            backgroundColor: "#1a3464",
                            color: "white",
                          }}>
                          <h6
                            className="card-title ml-2 mt-2"
                            style={{ color: "092a51" }}
                          >
                            {t("ClassScreen.ApplicableServices")}
                          </h6>
                        </div>
                      </div>

                      <div className="row search-filter-box">
                        <div className="col-lg-4">
                          <div className="autocomplete-wrappers"
                            style={{
                              zIndex: this.state.openEquipment ? 0 : "",
                            }}>
                            <label className="form-label required">{t("ShipEquipmentStatusScreen.Make")}</label>
                            <br></br>
                            <AutocompleteField
                              contentEditable={true}
                              value={this.state.MakeAndModelDetails.makeName}
                              inputProps={{ placeholder: `${t("MakeAndModelScreen.SelectMake")}` }}
                              items={MakeList ?? []}
                              getItemValue={(item) => item.name}
                              shouldItemRender={this.renderEquipmentTitle.bind(
                                this
                              )}
                              renderMenu={(item) => (
                                <div className="dropdown">{item}</div>
                              )}
                              renderItem={(item, isHighlighted) => (
                                <div
                                  className={`items ${isHighlighted ? "selected-items" : ""
                                    }`}
                                >
                                  {item.name}
                                </div>
                              )}
                              onChange={(e, field) =>
                                this.handleInputChanges(e, "makeName")
                              }
                              onSelect={(value, item) =>
                                this.handleSelectChange(
                                  value,
                                  "makeName",
                                  item.id,
                                  "makeId"
                                )
                              }
                            />
                          </div>
                        </div>
                      </div>
                      {this.renderMakeModelCard()}
                    </div>
                    <div className="row">
                      <div className="col-lg-12  mt-2">
                        <div
                          className="mb-2 search-btn-col"
                          style={{ textAlign: "end" }}
                        >
                          <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                            type="submit"
                            onClick={() => this.SubmitData()}
                          >
                            {t("ComplianceandBudgetScreen.Submit")}
                          </button>
                          <button
                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                            type="button"
                            onClick={() => this.moveClientList()}
                          >
                            {" "}
                            {t("ComplianceandBudgetScreen.Cancel")}{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  renderMakeModelCard = () => {
    const { t } = this.props;
    const ModelArray = this.state.ApplicableServicesList;
    return ModelArray && ModelArray.length ? (
      ModelArray?.map((item, index) => {
        return (
          <div
            className="card click m-3"
            style={{
              backgroundColor: "#f0f0f0",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <div className="p-3">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className="col-sm-9 col-md-10 col-9 m-auto">
                    <div className="row">
                      <div className="col-sm-3  py-1">
                        <span>
                          <strong>{t("ComplianceandBudgetScreen.MakeName")}: </strong>
                          {item.makeName}
                        </span>
                      </div>
                      <div className="col-sm-3  py-1">
                        <span>
                          <strong>{t("ComplianceandBudgetScreen.ModelName")}: </strong>
                          {item.modelName}
                        </span>
                      </div>
                      <div className="col-sm-3  py-1">
                        <span> <strong>{t("content.Servicetype")}: </strong>
                          {item.serviceType}
                        </span>
                      </div>
                      <div className="col-sm-3  py-1">
                        <span>
                          <strong>{t("ComplianceandBudgetScreen.Type")} : </strong>
                          {item.radioButton}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-2 col-sm-3 col-3 m-auto">
                    <div className="text-right" style={{ marginLeft: "-5px" }}>
                      <i
                        className="fa fa-edit fa-2x fa-lg click m-1 px-1"
                        onClick={() =>
                          this.showModal(item.Id, false, item.makeId, item.makeName, "", index)
                        }
                        aria-hidden="true"
                        style={{ color: " #1a3464", fontSize: "1.8rem" }}
                      ></i>
                      <i
                        className="fa fa-trash fa-2x click m-1 px-2"
                        onClick={() => this.deleteModel(index)}
                        aria-hidden="true"
                        style={{ color: " #1a3464", fontSize: "1.8rem" }}
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })
    ) : (
      <div
        className="card m-3"
        style={{ overflow: "hidden", position: "relative" }}
      >
        <div class="container">
          <h6 className="resource-list-title no-item-card">
            !--{t("CommonText.NoService")}--!
          </h6>
        </div>
      </div>
    );
  };

  moveClientList = () => {
    // this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.goBack();
  };
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    Loading: state.PageLoaderReducer.loading,
    EquipmentTypeList: state.MasterScreenReducer.EquipmentTypeList,
    CategoryList: state.MasterScreenReducer.CategoryList,
    serviceTypeList:
      state.MasterScreenReducer.applicableServiceTypeInterval || [],
    EquipmentDropdownList:
      state.MasterScreenReducer.EquipmentNameListAndId || [],
    MakeList: state.MasterScreenReducer.MakeList || [],
    ModelList: state.MasterScreenReducer.ModelList || [],
    applicableServiceTypeList:
      state.MasterScreenReducer.applicableServiceTypeList || [],
    attachmentDetail: state.SidePanReducer.attachmentDetail,
    GattachmentDetail: state.SidePanReducer.GattachmentDetail,
    EquipManualattachmentDetail: state.SidePanReducer.EquipManualattachmentDetail,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(EquipmentNewScreen));